import styled from '@emotion/styled';
import CreationBody from './CreationBody';
import useMediaQuery from '@mui/material/useMediaQuery';

const MainBody = styled('div')`
  width: 100%;
  max-width: 425px;
  margin: 130px auto 50px auto;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 6px 6px -3px,
    rgba(0, 0, 0, 0.14) 0px 10px 14px 1px, rgba(0, 0, 0, 0.12) 0px 4px 18px 3px;
  border-radius: 20px;
  @media only screen and (max-width: 600px) {
    margin: 20px auto;
  }
`;

const Body = (props: any) => {
  const matches = useMediaQuery('(min-width:600px)');

  return (
    <MainBody
      className="scrollbar-hidden"
      style={{ padding: matches ? '30px' : '0px' }}
    >
      <CreationBody />
    </MainBody>
  );
};

export default Body;
